export default __webpack_public_path__ + "static/media/two-circle-rtl.0a540f96.png";